import React, { FC, useContext, useEffect, useRef, useState } from 'react';

import { H3, NumberInput } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import { IPercentInputProps } from './interfces';
import s from './PercentInput.module.scss';

export const PercentInput: FC<IPercentInputProps> = ({
  setting,
  updateSetting,
  maxPercent,
  minPercent = 0,
  settingAlias,
  label,
  description,
  disabled,
}) => {
  const { t } = useContext(LocalizationContext);

  const ref = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState<number | ''>(setting);
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    setInputValue(setting);
  }, [setting]);

  return (
    <div className={s.container}>
      <div className={s.header}>
        <H3 className={s.label}>{label}</H3>
        {description && <span className={s.description}>{description}</span>}
      </div>
      <div className={s['percent']}>
        <NumberInput
          ref={ref}
          variant="secondary"
          error={error}
          value={inputValue}
          onChange={setInputValue}
          onEnter={() => ref.current?.blur()}
          onBlur={() => {
            if (inputValue === '' || inputValue < minPercent) {
              setError(t('errors.min', minPercent || '0', '%'));
              return;
            }

            if (maxPercent && inputValue > maxPercent) {
              setError(t('errors.max', maxPercent, '%'));
              return;
            } else {
              setError(undefined);
            }

            if (inputValue !== setting) {
              updateSetting({
                alias: settingAlias,
                value: JSON.stringify(inputValue),
              });
            }
          }}
          rightContent="%"
          bordered
          disabled={disabled}
        />
      </div>
    </div>
  );
};
